import React from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { Button, Icon } from '@pwc/pwc-deals-ui';
import { getOpenedProjectStatus } from '../../../features/project/projectSlice';
import { isProjectDisabled } from '../../helpers/projectStatusesUtils';
import './RowActionsButton.scss';

const RowActionsButton = ({ ...props }) => {
  const projectStatus = useSelector(getOpenedProjectStatus);
  const isDisabled = isProjectDisabled(projectStatus);
  return (
    <div className="row-actions-action-button-container">
      <Button
        {...props}
        className="button-link action-button"
        data-testid="row-actions-button"
        aria-label="Action Button"
        // disabled={isDisabled}
      >
        <Icon
          name="more-vert"
          width={24}
          className={classnames('fill icon-orange', {
            disabled: isDisabled,
          })}
        />
      </Button>
    </div>
  );
};

export default RowActionsButton;
